import { useLocation, useNavigate } from "react-router-dom"

//Components
import Snack from '../../components/snack'
import Loader from "../../components/loader"
import ModalPlayers from './components/modal-players'

//Extras
import { fontType } from "../../assets/extras"
import { TbVariablePlus } from "react-icons/tb"
import { useEffect, useState } from "react"
import { decomposeDate, getCurrentTime } from "../../assets/validator"
import { addDoc, arrayUnion, collection, doc, getDoc, getDocs, orderBy, query, updateDoc } from "firebase/firestore"
import { db } from "../../assets/connections"
import { FaTimes } from "react-icons/fa";   // Ícono de "X" (similar a cross)
import { IoAdd } from "react-icons/io5";
import { main } from "../../assets/coach-assets/constants/colors"
import NavBar from "./components/nav-bar"

const CoachExtraClass = () => {

    const navigate = useNavigate()

    const location = useLocation()
    const data = location.state ? location.state.data : null
    const ref = location.state ? location.state.ref : null
    const profesor = location.state ? location.state.profesor : null

    //Variables de la pantalla
    const [variables, setVariables] = useState({
        ref: ref,
        data: data,
        loading: true,
        allPlayers: [],
        modalP: false,
        lessons: [],
        calendarShow: false,
        readyToConfirm: null,
        selectedDate: new Date(),
        clase: {
            jugadores_noRegistrados: [],
            jugadores_registrados: [],
            comentarios_clase: "",
            descripcion_clase: data.descripcion_clase,
            duracion_clase: 1,
            fecha_clase: "",
            hora_clase: getCurrentTime(),
            leccion_clase: "",
            nombre_clase: data.nombre_clase,
            profesor_clase: profesor
        }
    })

    //Control del mensaje snack
    const showMessage = (message, status) => {
        setTimeout(() => {
            let contSnack = document.getElementById("contSnack")
    
            let snack = document.createElement("div")
            snack.classList.add("snack")
    
            snack.innerHTML = status == "success" ?
                "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #56d600;'></div>"
                : status == "warning" ?
                    "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                    : status == "error" ?
                        "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                        "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                        "<div className='snackBar' style='background-color: #c20000;'></div>"
                        : ""
    
            contSnack.appendChild(snack)
            setTimeout(() => {
                snack.remove()
            }, 5000)
        }, 5)
    }

    //Funcion que finaliza la clase
    const finishClass = (fecha) => {
        if (variables.clase.jugadores_registrados.length > 0 ||
            variables.clase.jugadores_noRegistrados.length > 0) {

            if(fecha != false && fecha != false){
                //Validamos que todos los campos esten llenos
                if (variables.clase.jugadores_noRegistrados.length > 0) {
                    let cont = 0
                    for (let i = 0; i < variables.clase.jugadores_noRegistrados.length; i++) {
                        if (variables.clase.jugadores_noRegistrados[i].nombre === "") {
                            cont++
                        }
                    }
    
                    if (cont > 0) {
                        setVariables(prev => ({
                            ...prev,
                            loading: false
                        }))
                        showMessage("Debes completar todos los nombres", "warning")
                    } else {
                        updateRegs(fecha)
                    }
                } else {
                    updateRegs(fecha)
                }
            } else {
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                showMessage("Vuelve a seleccionar la fecha", "warning")
            }

        } else {
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("No hay asistencias registradas", "warning")
        }
    }

    //Sube el registro a la bd
    const updateRegs = async (fecha) => {
        console.log(variables.data)
        //Primero obtenemos el documento de la clase que se va a registrar
        await getDoc(doc(doc(db, variables.ref), "Historial", variables.data.id)).then(r => {
            addReg(r.ref, fecha)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }
    const addReg = async (regRef, fecha) => {
        await addDoc(collection(regRef, "Historial"), {
            ...variables.clase,
            fecha_clase: fecha
        }).then(r => {
            updatingAsistances(fecha, r.id)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }

    //Actualiza las asistencias de todos los jugadores
    const updatingAsistances = (fecha, reg_id) => {
        //Priero tenemos que actualizar todas las asistencias de los alumnos
        let counter = 0
        variables.clase.jugadores_registrados.map(v => {
            if (updateAsistance(v.id, fecha, reg_id)) {
                counter++
            }
        })

        if (counter === variables.clase.jugadores_registrados.length) {
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Clase concluida!", "success")
            setTimeout(() => {
                navigate(-1, { replace: true });
            }, 2000)
        } else {
            showMessage("No se actualizaron todas las asistencias", "error")
            updateRegs(fecha)
        }
    }
    const updateAsistance = async (id, fecha, reg_id) => {
        await updateDoc(doc(doc(db, variables.ref), "Jugador", id),
            {
                asistencias: arrayUnion({
                    fecha_clase: fecha,
                    nombre_clase: variables.data.nombre_clase,
                    profesor_clase: variables.data.nombre_profesor,
                    hora_clase: "Dias asignados por el profesor",
                    id: reg_id
                })
            }
        ).then(r => {
            return true
        })
        return false
    }

    //Funcion que obtiene a todos los jugadores
    const getAllPlayers = async () => {
        setVariables(prev => ({
            ...prev,
            loading: true
        }))
        if (variables.allPlayers.length === 0) {
            await getDocs(query(collection(doc(db, variables.ref), "Jugador"), orderBy("nombre_jugador", "asc"))).then(r => {
                let aux = []
                r.docs.map((v, i) => {
                    aux.push({
                        id: v.id,
                        nombre_jugador: v.data().nombre_jugador
                    })
                })

                setVariables(prev => ({
                    ...prev,
                    allPlayers: aux,
                    modalP: true,
                    loading: false
                }))
            }).catch(e => {
                console.log(e.code + " " + e.message)
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                showMessage("Error de conexion", "error", 2000)
            })
        } else {
            setVariables(prev => ({
                ...prev,
                loading: false,
                modalP: true
            }))
        }
    }

    //Funcion que se ejecuta cada vez que se presiona un jugador
    const onPlayerPressed = (id, nombre, index) => {
        let players1 = variables.allPlayers
        let players2 = variables.clase.jugadores_registrados

        players1.splice(index, 1)
        players2.push({
            id: id,
            nombre: nombre
        })

        setVariables(prev => ({
            ...prev,
            modalP: false,
            allPlayers: players1,
            clase: {
                ...prev.clase,
                jugadores_registrados: players2
            }
        }))
    }

    //obtiene las lecciones de las clases
    const getLessons = async () => {
        await getDocs(query(collection(db, "Lecciones"))).then(r => {
            let aux = []
            r.docs.map(v => {
                aux.push(v.id)
            })

            setVariables(prev => ({
                ...prev,
                lessons: aux,
                loading: false
            }))
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            showMessage("Error de conexion", "error")
        })
    }

    useEffect(() => {
        const token = localStorage.getItem("authTokenCoach")

        if(!token || !location.state) {
            navigate("/coach", {
                replace: true
            })
        } else {
            getLessons()
        }
    }, [])

    if (variables.loading)
        return (
            <Loader
                loading={variables.loading}
            />
        )

    if (!TbVariablePlus.loading)
        return (
            <div style={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
            }}>
                <Snack />

                <ModalPlayers
                    variables={variables}
                    setVariables={setVariables}
                    players={variables.allPlayers}
                    modalP={variables.modalP}
                    addNewPlayer={onPlayerPressed}
                />

                <NavBar
                    title={"CLASE EXTRACURRICULAR"}
                />

                <h3
                    style={{
                        width: "100%",
                        paddingLeft: 10,
                        marginTop: 30,
                        marginBottom: 10,
                        fontFamily: fontType.title,
                        textAlign: "center",
                        fontSize: 30
                    }}
                >
                    Jugadores
                </h3>

                <div
                    style={{
                        borderWidth: 1,
                        borderStyle: "solid",
                        borderRadius: 5,
                        padding: 10,
                        width: "80%",
                        maxWidth: 800
                    }}
                >
                    {/* Jugadores no registrados */}
                    {variables.clase.jugadores_noRegistrados.map((v, i) => (
                        <div
                            key={`no-${i}`}
                            style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                flexDirection: "row",
                            }}
                        >
                            <input
                                type="text"
                                style={{
                                    borderRadius: 5,
                                    borderWidth: 1,
                                    borderStyle: "solid",
                                    width: "80%",
                                    height: 40,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    marginTop: 5,
                                    marginBottom: 10,
                                    color: "black",
                                }}
                                placeholder="Nombre"
                                defaultValue={v.nombre}
                                onBlur={(e) => {
                                    const t = e.target.value;
                                    let players = [...variables.clase.jugadores_noRegistrados];
                                    players[i].nombre = t;

                                    setVariables((prev) => ({
                                        ...prev,
                                        clase: {
                                            ...prev.clase,
                                            jugadores_noRegistrados: players,
                                        },
                                    }));
                                }}
                            />

                            <button
                                style={{ padding: 4, background: "transparent", border: "none" }}
                                onClick={() => {
                                    const players = [...variables.clase.jugadores_noRegistrados];
                                    players.splice(i, 1);
                                    setVariables((prev) => ({
                                        ...prev,
                                        clase: { ...prev.clase, jugadores_noRegistrados: players },
                                    }));
                                }}
                            >
                                <FaTimes size={24} color="#990000" />
                            </button>
                        </div>
                    ))}

                    {/* Jugadores registrados */}
                    {variables.clase.jugadores_registrados.map((v, i) => (
                        <div
                            key={`reg-${i}`}
                            style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                flexDirection: "row",
                            }}
                        >
                            <input
                                type="text"
                                style={{
                                    borderRadius: 5,
                                    borderWidth: 1,
                                    borderStyle: "solid",
                                    width: "80%",
                                    height: 40,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    marginTop: 5,
                                    marginBottom: 10,
                                    color: "black",
                                }}
                                placeholder={v.nombre}
                                disabled
                            />

                            <button
                                style={{ padding: 4, background: "transparent", border: "none" }}
                                onClick={() => {
                                    const players = [...variables.clase.jugadores_registrados];
                                    players.splice(i, 1);
                                    setVariables((prev) => ({
                                        ...prev,
                                        clase: { ...prev.clase, jugadores_registrados: players },
                                    }));
                                }}
                            >
                                <FaTimes size={24} color="#990000" />
                            </button>
                        </div>
                    ))}

                    {/* Botón para agregar jugador */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: 20,
                            flexDirection: "column"
                        }}
                    >
                        <button
                            style={{
                                height: 45,
                                width: 45,
                                backgroundColor: main,
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                border: "none",
                                cursor: "pointer",
                            }}
                            onClick={() => {
                                const players = [...variables.clase.jugadores_noRegistrados];
                                players.push({ nombre: "" });
                                setVariables((prev) => ({
                                    ...prev,
                                    clase: { ...prev.clase, jugadores_noRegistrados: players },
                                }));
                            }}
                        >
                            <IoAdd size={24} color="white" />
                        </button>
                    </div>
                </div>

                {/* Botón buscar jugador */}
                <button
                    style={{
                        backgroundColor: main,
                        padding: "15px",
                        marginTop: "10px",
                        borderRadius: "5px",
                        border: "none",
                        cursor: "pointer",
                    }}
                    onClick={getAllPlayers}
                >
                    <span
                        style={{
                            color: "white",
                            fontFamily: fontType.title,
                        }}
                    >
                        BUSCAR JUGADOR
                    </span>
                </button>

                {/* Texto Lecciones */}
                <p
                    style={{
                        marginTop: "25px",
                        fontSize: "16px",
                        fontFamily: fontType.title,
                    }}
                >
                    Lecciones
                </p>

                {/* Selector de lecciones */}
                <div
                    style={{
                        width: "90%",
                        borderWidth: "1px",
                        borderStyle: "solid",
                        borderRadius: "10px",
                        marginTop: "5px",
                        borderColor: "#ddd",
                        backgroundColor: "white",
                        maxWidth: 700
                    }}
                >
                    <select
                        value={variables.clase.leccion_clase}
                        onChange={(e) =>
                            setVariables((prev) => ({
                                ...prev,
                                clase: {
                                    ...prev.clase,
                                    leccion_clase: e.target.value,
                                },
                            }))
                        }
                        style={{
                            width: "100%",
                            padding: "10px",
                            border: "none",
                            borderRadius: "10px",
                            color: "black",
                            backgroundColor: "white",
                            outline: "none"
                        }}
                    >
                        <option value="">Seleccionar lección</option>
                        {variables.lessons.map((v, i) => (
                            <option key={i} value={v}>
                                {v}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Comentarios */}
                <div style={{ marginTop: "30px", width: "90%", maxWidth: 700 }}>
                    <p style={{
                        fontFamily: fontType.title
                    }}>Comentarios</p>
                    <input
                        type="text"
                        style={{
                            width: "100%",
                            height: "40px",
                            borderWidth: "1px",
                            borderStyle: "solid",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                            borderRadius: "5px",
                            marginTop: "3px",
                            color: "black",
                        }}
                        placeholder="..."
                        maxLength={150}
                        defaultValue={variables.clase.comentarios_clase}
                        onBlur={(e) => {
                            const t = e.target.value;
                            setVariables((prev) => ({
                                ...prev,
                                clase: {
                                    ...prev.clase,
                                    comentarios_clase: t,
                                },
                            }));
                        }}
                    />
                </div>

                {/* Duración de clase */}
                <p style={{ marginTop: "20px", width: "90%", fontFamily: fontType.title, maxWidth: 700 }}>Duración de clase</p>

                <div style={{ marginTop: "5px", width: "90%", maxWidth: 700 }}>
                    <div
                        style={{
                            width: "100%",
                            borderWidth: "1px",
                            borderStyle: "solid",
                            borderRadius: "10px",
                            marginTop: "5px",
                            borderColor: "#ddd",
                            backgroundColor: "white",
                        }}
                    >
                        <select
                            value={variables.clase.duracion_clase}
                            onChange={(e) =>
                                setVariables((prev) => ({
                                    ...prev,
                                    clase: {
                                        ...prev.clase,
                                        duracion_clase: e.target.value,
                                    },
                                }))
                            }
                            style={{
                                width: "100%",
                                padding: "10px",
                                border: "none",
                                borderRadius: "10px",
                                color: "black",
                                backgroundColor: "white",
                                outline: "none",
                            }}
                        >
                            <option value={1}>1 Hora</option>
                            <option value={2}>2 Horas</option>
                            <option value={3}>3 Horas</option>
                            <option value={4}>4 Horas</option>
                            <option value={5}>5 Horas</option>
                            <option value={6}>6 Horas</option>
                            <option value={7}>7 Horas</option>
                            <option value={8}>8 Horas</option>
                        </select>
                    </div>
                </div>

                {/* Calendario */}
                {
                    <input
                        type="date"
                        style={{ 
                            padding: 8,
                            fontSize: 16,
                            borderRadius: 5,
                            border: "1px solid #ccc",
                            marginTop: 20
                            }}
                        onChange={(e) => {
                            const [year, month, day] = e.target.value.split("-"); 

                            // Construir fecha localmente sin que se desplace por timezone
                            const sD = new Date(year, month - 1, day);

                            let aux = `${year}-${month}-${day}`;

                            setVariables((prev) => ({
                                ...prev,
                                selectedDate: sD,
                                readyToConfirm: aux,
                                //calendarShow: false
                            }));
                        }}
                    />
                }

                {/* Botón finalizar clase */}
                {
                    variables.readyToConfirm != null ?
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            width: "70%",
                            maxWidth: 400
                        }}>
                            <button
                                style={{
                                    marginTop: 10,
                                    marginBottom: 10,
                                    backgroundColor: "#4e6b4eff",
                                    width: "100%",
                                    borderRadius: 10,
                                    borderStyle: "none",
                                    color: "white",
                                    fontFamily: fontType.title,
                                    fontSize: 18,
                                    padding: 10,
                                    border: "none",
                                    cursor: "pointer",
                                }}
                                onClick={() => {
                                    setVariables((prev) => ({
                                        ...prev,
                                        loading: true,
                                    }));
                                    console.log(variables.readyToConfirm)
                                    finishClass(variables.readyToConfirm);
                                }}
                            >
                                CONFIRMAR CLASE
                            </button>
                            <p style={{
                                fontFamily: fontType.title
                            }}>{decomposeDate(variables.readyToConfirm)}</p>
                        </div>
                        : null
                }

            </div>
        )
}

export default CoachExtraClass